/**
 * Formatte les erreurs API pour quelles soient normalisées.
 */
const errorMonolithFormatErrors = ({ errorList, intl }) => {
  const newErrorList = {};

  for (const errorName of Object.keys(errorList)) {
    let error = errorList[errorName];

    let match;

    if ("Value is required and can't be empty" === error) {
      error = intl.formatMessage({
        defaultMessage: "Le champs est requis.",
      });
    } else if (
      "The input is not a valid email address. Use the basic format local-part@hostname" ===
      error
    ) {
      error = intl.formatMessage({
        defaultMessage: "Le champs n’est pas une adresse e-mail valide.",
      });
    } else if ("The input is not valid" === error) {
      error = intl.formatMessage({
        defaultMessage: "Le champs n’est pas valide.",
      });
    } else if (
      (match = /The input is not between '(\d+)' and '(\d+)', inclusively/.exec(
        error
      ))
    ) {
      error = intl.formatMessage(
        {
          defaultMessage: "Le champs doit être compris entre {min} et {max}.",
        },
        { min: match[1], max: match[2] }
      );
    }

    newErrorList[errorName] = [error];
  }

  return newErrorList;
};

export default errorMonolithFormatErrors;
